import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "FacebookFeed",
    component: () => (__SERVER__ ? require("./facebook-feed-view") : import("./facebook-feed-view"))
});

export default definition;
